const messageGetter = x => x.message

export function defaultValidatorErrorsParser(errors) {
  return Object.keys(errors).reduce((acc, x) => {
    acc[x] = errors[x].map(messageGetter)
    return acc
  }, {})
}

export default {
  data() {
    return {
      data: {},
      isLoad: false,
    }
  },
  methods: {
    catchFormErrors(promise) {
      return promise.catch(e => {
        let clientError = 400
        let serverError = 500
        if (!e.status || clientError > e.status || serverError <= e.status) {
          throw e
        }

        if (!this.updateValidator) {
          return e
        }
        return e.json().then(body => {
          const errors = {}
          body.errors.forEach(error => {
            if ('request' === error.domain && error.state) {
              Object.assign(errors, error.state)
            }
          })

          this.updateValidator(errors)

          return e
        })
      })
    },
    submit(isValid) {
      if (!isValid) {
        return Promise.reject()
      }

      this.isLoad = true
      return this.catchFormErrors(this.send(this.formdata))
        .finally(() => {
          this.isLoad = false
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/mixins/form-mixin.js